import React from 'react';

interface Props {
  content: any;
}

const FormatHtml: React.FC<Props> = ({ content }) => (
  <div
    className="markdown code-container"
    dangerouslySetInnerHTML={{
      __html: content
    }}
  />
);

export default FormatHtml;
